import React, { memo } from "react";
import styled from "styled-components";
import { LanguageSwitcher } from "../language-switcher/language-switcher";
import { moduleSettings } from "../../stores/module-settings.store";
import { useTranslation } from "react-i18next";
import { HeaderStyle } from "../../types";
import { useLocation } from "react-router-dom";
import { cancelPendingBookingRequest } from "../../requests/pending-booking.requests";
import { ActionButton } from "../action-button/action-button";
import { config } from "../../config";
import { pendingBookingStore } from "../../stores/pending-booking.store";
import { UpdateBanner } from "../update-banner/update-banner";
interface HeaderProps {
  onHeaderClick?: () => void;
}

interface IStyle {
  callFromFloatingButton: boolean;
  fontFamily: string;
}

const HeaderWrapper = styled.div<IStyle>`
  height: ${(props) => props.theme.headerHeight};
  width: 100%;
  background-color: ${(props) =>
    props.theme.headerStyle === HeaderStyle.text
      ? "white"
      : props.theme.headerBackgroundColor};
  color: ${(props) =>
    props.theme.headerStyle === HeaderStyle.text
      ? props.theme.headerBackgroundColor
      : props.theme.invertFontColor};
  font-family: ${(props) => props.fontFamily};
  box-shadow: ${(props) =>
    props.theme.headerStyle === HeaderStyle.text
      ? "0 2px 4px rgba(0, 0, 0, 0.25)"
      : "none"};
  padding: 8px 20px;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  overflow: hidden;
  justify-content: ${(props) =>
    props.callFromFloatingButton ? "center" : "inherit"};

  @media screen and (min-width: 781px) {
    justify-content: center;
  }
`;

const LanguageSwitcherWrapper = styled.div`
  position: absolute;
  right: 40px;
  width: 45px;
`;

interface DisplayPointerI {
  displayPointer: boolean;
}

const ReserveOnline = styled.div<DisplayPointerI>`
  font-size: 18px;
  line-height: 22px;
  max-width: calc(100% - 55px);
  &:hover {
    cursor: ${(props) => (props.displayPointer === false ? null : "pointer")};
  }
  span {
    font-weight: bold;
  }

  @media screen and (max-width: 780px) {
    font-size: 16px;
    line-height: 19px;
  } ;
`;

const RestaurantLogo = styled.img<DisplayPointerI>`
  cursor: ${(props) => (props.displayPointer === false ? null : "pointer")};
  max-height: 50px;
  max-width: 100%;
`;

const CloseButton = styled.div`
  position: absolute;
  left: 12px;
  top: 9px;
`;

const HeaderDef = (props: HeaderProps) => {
  const restaurantName = moduleSettings.getRestaurantName();
  const restaurantLogoUrl = moduleSettings.restaurantLogoUrl;
  const callFromFloatingButton = moduleSettings.callFromFloatingButton;
  const fontFamily = moduleSettings.fontFamily;
  const referralKey = moduleSettings.getReferralKey();
  const redirectUrl = `${config.baseUrl}/instabook/cta/${referralKey}`;
  const { t } = useTranslation();
  const location = useLocation();
  const isUpdateFromBooking = moduleSettings.isUpdateFromBooking;

  const goHome = () => {
    if (callFromFloatingButton) {
      return;
    }
    let needToCancelPending =
      location.pathname.endsWith("selection") ||
      location.pathname.endsWith("confirmationEnd");

    if (!needToCancelPending) {
      pendingBookingStore.resetBookingState();
      cancelPendingBookingRequest();
    }
    if (props.onHeaderClick === undefined) {
      return;
    }
    props.onHeaderClick!();
  };

  const content = restaurantLogoUrl ? (
    <RestaurantLogo
      displayPointer={props.onHeaderClick !== undefined}
      onClick={goHome}
      src={restaurantLogoUrl}
      alt=""
    />
  ) : (
    <ReserveOnline displayPointer={props.onHeaderClick !== undefined}>
      {props.onHeaderClick !== undefined && t("instabook.button_txt")}{" "}
      <span onClick={goHome}>{restaurantName}</span>
    </ReserveOnline>
  );

  return (
    <>
      <HeaderWrapper
        data-test="header"
        callFromFloatingButton={callFromFloatingButton}
        fontFamily={fontFamily}
      >
        {callFromFloatingButton && (
          <CloseButton>
            <ActionButton
              route={redirectUrl}
              cancelPB={true}
              action={"close"}
            />
          </CloseButton>
        )}
        {content}
        <LanguageSwitcherWrapper>
          <LanguageSwitcher />
        </LanguageSwitcherWrapper>
      </HeaderWrapper>
      {isUpdateFromBooking && <UpdateBanner />}
    </>
  );
};
export const Header = memo(HeaderDef);
